<template lang="pug">
  Sidebar

    div.d-flex.justify-content-end.align-items-center.custom-sidebar
      SidebarHeader.flex-fill
        template
          div.d-flex.justify-content-end
            div.p-1.align-self-center.flex-fill.text-left
              span {{ $store.getters.displayName }}
            b-link.align-self-center(to="/system/setting" v-b-tooltip.hover :title="$t('ui.settings')").mr-1
              i.p-1.fa.fa-sliders-h
            b-link.align-self-center(to="/logout" v-b-tooltip.hover :title="$t('ui.logout')")
              i.p-1.fa.fa-sign-out-alt
      SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
    SidebarNav(:navItems="navItems")
    //- SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
</template>

<script>
import config from "@/config";
import { Sidebar, SidebarHeader, SidebarNav, SidebarMinimizer } from "@/library/coreui";

export default {
  components: {
    Sidebar,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  computed: {
    navItems() {
      return [
        {
          name: this.$t("ui.dashboard"),
          icon: "nav-icon cui-dashboard",
          url: "/system/dashboard"
        },
        {
          name: this.$t("ui.account"),
          icon: "fa fa-users",
          pages: [config.accessRoles.account],
          children: [
            {
              name: this.$tc("ui.operators", 1),
              url: "/account/operator",
              icon: "fa fa-users",
              pages: [config.accessRoles.operator],
            },
            {
              name: this.$tc("ui.members", 2),
              url: "/account/member",
              icon: "fa fa-users",
              pages: [config.accessRoles.member]
            },
            {
              name: this.$t("ui.member_nickname"),
              url: "/account/membernickname",
              icon: "fa fa-users",
              pages: [config.accessRoles.membernickname]
            },
            {
              name: this.$t("ui.social_account"),
              url: "/account/socialaccount",
              icon: "far fa-address-card",
              pages: [config.accessRoles.socialaccount]
            },
            {
              name: this.$t("ui.sub_account"),
              url: "/account/subaccount",
              icon: "fa fa-users",
              pages: [config.accessRoles.subaccount]
            }
          ]
        },
        {
          name: this.$tc("ui.tickets", 1),
          icon: "fas fa-list-alt",
          url: "/ticket",
          pages: [config.accessRoles.ticket],
        },
        {
          name: this.$tc("ui.banks", 1),
          icon: "fas fa-landmark",
          pages: [config.accessRoles.bank],
          children: [
            {
              name: this.$t("ui.bank_operator"),
              url: "/bank/bankOperator",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.bankoperator],
            },
            {
              name: this.$t("ui.bank_member"),
              url: "/bank/bankMember",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.bankmember]
            }
          ]
        },
        {
          name: this.$t("ui.ibank"),
          icon: "fas fa-money-bill-alt",
          pages: [config.accessRoles.bank],
          children: [
            {
              name: this.$t("ui.ibank_account"),
              url: "/ibank/ibankAccount",
              icon: "fas fa-money-bill-alt",
              pages: [config.accessRoles.ibankaccount],
            },
          ]
        },
        {
          name: this.$t("ui.promotion"),
          icon: "fas fa-gift",
          pages: [config.accessRoles.promotion],
          children: [
            {
              name: this.$t("ui.promotion_package"),
              url: "/promotion/promoPackage",
              icon: "fas fa-list",
              pages: [config.accessRoles.promopackage],
            },
            {
              name: this.$t("ui.promotion_account"),
              url: "/promotion/promoAccount",
              icon: "fas fa-list",
              pages: [config.accessRoles.promoaccount]
            },
            {
              name: this.$t("ui.promotion_member"),
              url: "/promotion/promoMember",
              icon: "fas fa-list",
              pages: [config.accessRoles.promomember]
            }
          ]
        },
        {
          name: this.$t("ui.log"),
          icon: "fa fa-search",
          children: [
            {
              name: this.$t("ui.member_log"),
              url: "/log/adjustMemberLog",
              icon: "fa fa-file",
            },
            {
              name: this.$t("ui.bonus_log"),
              url: "/log/issueBonusLog",
              icon: "fa fa-file",
            },
            {
              name: this.$t("ui.login_log"),
              url: "/log/loginMemberLog",
              icon: "fa fa-file",
            }
          ]
        },
        {
          name: this.$t("ui.report"),
          icon: "fa fa-chart-line",
          children: [
            {
              name: this.$t("ui.daily_statement"),
              url: "/report/dailyStatement",
              icon: "fa fa-chart-line",
            },
            {
              name: this.$t("ui.daily_winlose"),
              url: "/report/dailyWinLose",
              icon: "fa fa-chart-line",
            },
            {
              name: this.$t("ui.game_result"),
              url: "/report/gameResultSlots",
              icon: "fa fa-poll-h",
            },
            {
              name: this.$t("ui.bank_statement"),
              url: "/report/bankStatement",
              icon: "fa fa-poll-h",
            },
            {
              name: this.$t("ui.promotion_report"),
              url: "/report/promotionReport",
              icon: "fa fa-poll-h",
            },
            {
              name: this.$t("ui.registered_member"),
              url: "/report/registeredMember",
              icon: "fa fa-poll-h",
            },
            {
              name: this.$t("ui.deposited_member"),
              url: "/report/depositedMember",
              icon: "fa fa-poll-h",
            },
            {
              name: this.$t("ui.first_deposit"),
              url: "/report/firstDeposit",
              icon: "fa fa-poll-h",
            },
            {
              name: this.$t("ui.referred_member"),
              url: "/report/referredMember",
              icon: "fa fa-poll-h",
            },
          ]
        },
        {
          name: this.$t("ui.report_downline"),
          icon: "fa fa-chart-line",
          pages: [config.accessRoles.reportdownline],
          children: [
            {
              name: this.$t("ui.downline_operator"),
              url: "/reportNest/downlineOperator",
              icon: "fa fa-users",
              pages: [config.accessRoles.downlineoperator],
            },
            {
              name: this.$t("ui.daily_statement"),
              url: "/reportNest/dailyStatementNest",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailystatementnest],
            },
            {
              name: this.$t("ui.daily_winlose"),
              url: "/reportNest/dailyWinLoseNest",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailywinlosenest],
            },
          ]
        }
      ];
    }
  },
  methods: {
    handleMinimized(e) {
      this.$store.dispatch("layout/setSidebarMinimized", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-sidebar {
  background: rgba(0, 0, 0, 0.4);
  -webkit-box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
  .sidebar-header {
    background: transparent;
    box-shadow: none;
  }
}
</style>
